
import React from 'react';
import { Monitor, Camera, PenTool, BarChart3, Code, Layout, Server, Smartphone, Lightbulb, Home, Mic, Video } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ServiceCard from '../ui/ServiceCard';
import ScrollReveal from '../ui/ScrollReveal';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      icon: <Layout />,
      title: 'Website Design & Development',
      description: 'Custom websites designed for conversion and user experience, built with modern technologies and optimized for performance.',
      badge: 'Web',
      link: '/services/website-design'
    },
    {
      icon: <Camera />,
      title: 'Professional Photography',
      description: 'High-quality photography services for various industries including real estate, fashion, food, events, and lifestyle brands.',
      badge: 'Visual',
      link: '/services/photography'
    },
    {
      icon: <BarChart3 />,
      title: 'Digital Marketing',
      description: 'Comprehensive marketing strategies including social media management, content creation, and paid advertising campaigns.',
      badge: 'Marketing',
      link: '/services/marketing'
    },
    {
      icon: <Monitor />,
      title: 'SEO Services',
      description: 'Search engine optimization to improve your visibility online and drive organic traffic to your website.',
      badge: 'Growth',
      link: '/services/seo'
    },
    {
      icon: <PenTool />,
      title: 'Branding & Identity',
      description: 'Brand development including logo design, messaging, and creating a cohesive identity that resonates with your audience.',
      badge: 'Branding',
      link: '/services/branding'
    },
    {
      icon: <Code />,
      title: 'Software Solutions',
      description: 'Custom software, CRM systems, and all-in-one platforms designed to streamline operations and enhance business efficiency.',
      badge: 'Technology',
      link: '/services/software'
    },
    {
      icon: <Server />,
      title: 'IT Services',
      description: 'Comprehensive IT support, network management, cybersecurity, and technology solutions for businesses of all sizes.',
      badge: 'IT',
      link: '/services/it'
    },
    {
      icon: <Smartphone />,
      title: 'App Development',
      description: 'Custom mobile and web application development that delivers intuitive, high-performance solutions for various platforms.',
      badge: 'Development',
      link: '/services/app-development'
    },
    {
      icon: <Lightbulb />,
      title: 'Tech Consulting',
      description: 'Strategic technology guidance to help businesses make informed decisions and implement effective digital solutions.',
      badge: 'Consulting',
      link: '/services/tech-consulting'
    },
    {
      icon: <Home />,
      title: 'Real Estate Media',
      description: 'Specialized media services for real estate professionals including photography, virtual tours, and promotional content.',
      badge: 'Real Estate',
      link: '/services/real-estate-media'
    },
    {
      icon: <Mic />,
      title: 'Tech Coaching',
      description: 'Personalized coaching for podcast creation, AI implementation, automation, and digital transformation for businesses and individuals.',
      badge: 'Coaching',
      link: '/services/tech-coaching'
    },
    {
      icon: <Video />,
      title: 'Virtual Tours',
      description: 'Custom 360° immersive virtual tours for businesses, real estate, hospitality, and more. Better than Matterport with affordable pricing.',
      badge: 'Interactive',
      link: '/services/virtual-tours'
    }
  ];

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <span className="inline-block px-3 py-1 bg-astrem-gray-100 text-astrem-gray-800 rounded-full text-sm font-medium mb-4">
            Our Services
          </span>
        </ScrollReveal>
        
        <ScrollReveal delay={100}>
          <h2 className="section-title">What We Offer</h2>
        </ScrollReveal>
        
        <ScrollReveal delay={200}>
          <p className="section-description text-balance">
            We provide comprehensive digital solutions to help businesses and individuals establish a strong online presence and achieve their goals.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.slice(0, 6).map((service, index) => (
            <ScrollReveal key={index} delay={300 + (index * 100)}>
              <ServiceCard
                icon={service.icon}
                title={service.title}
                description={service.description}
                badge={service.badge}
                href={service.link}
              />
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={800} className="mt-12 text-center">
          <Button asChild className="bg-astrem-black hover:bg-astrem-gray-800 text-white rounded-full px-6">
            <Link to="/services">View All Services</Link>
          </Button>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Services;
